export const HEADERS = {
    cookie: "Cookie",
    content_type: "Content-Type",
    authorization: "Authorization",
};

export const CONTENT_TYPES = {
    json: "application/json"
};

export const METHODS = {
    post: "post",
    get: "get",
    put: "put",
    delete: "delete"
};